export default __webpack_public_path__ + "static/media/ico_folder.12b32220.png";